import { useRollbar } from '@rollbar/react'
import { useCallback, useState } from 'react'
import toast from 'react-hot-toast'
import { LocaleEnum } from '@systemeio/ui-frontend'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import useUser from 'shared/hooks/use-user'
import { changeLocale } from 'shared/i18n/change-locale'

export const useLanguageSwitcher = () => {
  const rollbar = useRollbar()
  const { i18n, t } = useTranslation()
  const router = useRouter()
  const { user, mutate } = useUser()
  const [isChangingLanguage, setIsChangingLanguage] = useState(false)

  const handleChangeLanguage = useCallback(
    async (locale: LocaleEnum, options?: { forceRouterUpdate?: boolean }) => {
      try {
        setIsChangingLanguage(true)
        await changeLocale({
          i18n,
          locale,
          disableBackendUpdate: !user,
          userDashboardLocale: user?.dashboardLocale,
          mutateUser: mutate,
          revalidateUser: true,
          router,
          forceRouterUpdate: options?.forceRouterUpdate,
        })
      } catch (error) {
        const err = error as Error
        rollbar.error('Failed to change language', err)
        toast.error(t('errors.language_change_failed'))
      } finally {
        setIsChangingLanguage(false)
      }
    },
    [i18n, mutate, rollbar, router, t, user],
  )
  return { handleChangeLanguage, isChangingLanguage }
}
